import { render } from "./DeliveryPersonsActionMenu.vue?vue&type=template&id=01f7ae6f&scoped=true"
import script from "./DeliveryPersonsActionMenu.vue?vue&type=script&lang=js"
export * from "./DeliveryPersonsActionMenu.vue?vue&type=script&lang=js"

import "./DeliveryPersonsActionMenu.vue?vue&type=style&index=0&id=01f7ae6f&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f7ae6f"]])

export default __exports__